import { Injectable } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class CheckboxesService {
	allLength: number = 0;
	changeDetection: ReplaySubject<void> = new ReplaySubject<void>(1); // subject, який сповіщає про будь-яку зміну в чекбоксах
	excluded: SelectionModel<number> = new SelectionModel<number>(true, []);
	isIndeterminate: boolean = false;
	isSelectedAll: boolean = false;
	selectedLength: number = 0;
	selection: SelectionModel<number> = new SelectionModel<number>(true, []);
	showSelectedAll: boolean = false;

	get selectedObject(): { ids?: string, exclude_ids?: string } {
		const object: { ids?: string, exclude_ids?: string } = {};
		if (this.selection.hasValue())
			object.ids = this.selection.selected.join(',');
		if (this.excluded.hasValue())
			object.exclude_ids = this.excluded.selected.join(',');
		return object;
	}

	// порахувати кількість вибраних
	private calcSelectedLength(): void {
		this.selectedLength = this.isSelectedAll
			? this.allLength - this.excluded.selected.length
			: this.selection.selected.length;

		this.changeDetection.next();
	}

	// проставити всі статуси
	private checkStatutes(): void {
		if (this.allLength === this.selection.selected.length) {
			this.showSelectedAll = true;
			this.isSelectedAll = true;
			this.isIndeterminate = false;
			this.selection.clear();
			this.excluded.clear();
		}

		if (this.allLength === this.excluded.selected.length) this.clear();

		if (!this.allLength) {
			this.showSelectedAll = false;
			this.isSelectedAll = false;
		}

		this.isIndeterminate = (this.isSelectedAll && this.excluded.hasValue()) || (this.selection.hasValue());
		this.showSelectedAll = this.isSelectedAll && !this.isIndeterminate;

		this.calcSelectedLength();
	}

	// деактивувати чекбокс
	private deselect(row: number): void {
		if (this.isSelectedAll) {
			this.excluded.select(row);
		} else {
			this.selection.deselect(row);
		}
	}

	// активувати чекбокс
	private select(row: number): void {
		if (this.isSelectedAll) {
			this.excluded.deselect(row);
		} else {
			this.selection.select(row);
		}
	}

	// очистити всі вибрані
	clear(): void {
		this.isSelectedAll = false;
		this.showSelectedAll = false;
		this.isIndeterminate = false;
		this.selection.clear();
		this.excluded.clear();
		this.calcSelectedLength();
	}

	// ініціалізувати заново
	init(count: number, disabledCount?: number): void {
		this.allLength = count - (disabledCount || 0);
		this.checkStatutes();
	}

	// перевірити чи елемент обраний
	isChecked(key: number): boolean {
		if (!this.selectedLength) return false;
		return (
			this.isSelectedAll && !this.excluded.isSelected(key) ||
			!this.isSelectedAll && this.selection.isSelected(key)
		);
	}

	// зміна загального чекбоксу
	masterToggle(): void {
		this.isSelectedAll = !this.isSelectedAll || this.isIndeterminate;
		this.selection.clear();
		this.excluded.clear();
		this.checkStatutes();
	}

	// заблокувати чекбокс
	setDisabled(id: number): void {
		if (this.selection.isSelected(id)) this.selection.deselect(id);
		if (this.isSelectedAll && this.excluded.isSelected(id)) this.excluded.deselect(id);
		this.checkStatutes();
	}

	// розблокувати чекбокс
	setEnabled(id): void {
		if (this.isSelectedAll) this.excluded.select(id);
		this.checkStatutes();
	}

	// зміна чекбоксу
	toggle(row: number, checked: boolean): void {
		checked ? this.select(row) : this.deselect(row);
		this.checkStatutes();
	}
}